var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-white",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.txid))])}
var staticRenderFns = []

export { render, staticRenderFns }